import React, { useState, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

function Login({ onClose, promptReason = '' }) {
  const { signInWithGoogle, loading } = useContext(AuthContext);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleGoogleSignIn = async () => {
    setError('');
    setSuccess('');

    try {
      await signInWithGoogle();
      setSuccess('Signed in with Google. Redirecting...');
      setTimeout(() => onClose(), 1000);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-slate-900/40 px-4 py-8 sm:px-6">
      <div className="mx-auto max-w-md rounded-[32px] bg-white p-6 shadow-2xl sm:p-10">
        <div className="flex items-center justify-between gap-4 border-b border-slate-200 pb-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">Sign in</p>
            <h2 className="mt-2 text-2xl font-semibold text-slate-900">Continue with Google</h2>
          </div>
          <button type="button" onClick={onClose} className="text-slate-500 transition hover:text-slate-900">✕</button>
        </div>

        <div className="mt-6 space-y-4">
          <p className="text-sm text-slate-600">
            Use your Google account to sign in securely.
          </p>

          {promptReason === 'guest-limit' && (
            <div className="rounded-3xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
              Your one free guest review has been used. Sign in to post more reviews.
            </div>
          )}

          {error && (
            <div className="rounded-3xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-800">
              {error}
            </div>
          )}

          {success && (
            <div className="rounded-3xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
              {success}
            </div>
          )}

          <button
            type="button"
            onClick={handleGoogleSignIn}
            disabled={loading}
            className="flex w-full items-center justify-center gap-3 rounded-3xl border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-800 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
              <path fill="#EA4335" d="M12 11.818v4.764h6.764c-.291 1.527-1.164 2.818-2.473 3.691l4 3.109c2.327-2.146 3.673-5.309 3.673-9.055 0-.855-.073-1.673-.209-2.509H12Z"/>
              <path fill="#34A853" d="M5.564 14.282 4.664 14.97l-3.182 2.478A11.99 11.99 0 0 0 12 24c3.236 0 5.945-1.073 7.927-2.909l-4-3.109c-1.073.727-2.436 1.164-3.927 1.164-3.109 0-5.745-2.1-6.691-4.945l-.745.082Z"/>
              <path fill="#4A90E2" d="M1.482 6.552A11.93 11.93 0 0 0 0 12c0 1.964.473 3.818 1.482 5.448l4.827-3.754A7.2 7.2 0 0 1 5.927 12c0-.6.109-1.182.327-1.691L1.482 6.552Z"/>
              <path fill="#FBBC05" d="M12 4.773c1.764 0 3.345.609 4.6 1.8l3.454-3.454C17.945 1.164 15.236 0 12 0A11.99 11.99 0 0 0 1.482 6.552l4.772 3.757C7.2 6.873 8.891 4.773 12 4.773Z"/>
            </svg>
            {loading ? 'Signing in...' : 'Sign in with Google'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
